/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OnboardingResponseDto
 */
export interface OnboardingResponseDto {
    /**
     * Stripe onboarding URL (valid for 24 hours)
     * @type {string}
     * @memberof OnboardingResponseDto
     */
    onboardingUrl: string;
    /**
     * Stripe Connect account ID
     * @type {string}
     * @memberof OnboardingResponseDto
     */
    accountId: string;
    /**
     * Whether this is a new account or existing
     * @type {boolean}
     * @memberof OnboardingResponseDto
     */
    isNewAccount: boolean;
}

/**
 * Check if a given object implements the OnboardingResponseDto interface.
 */
export function instanceOfOnboardingResponseDto(value: object): value is OnboardingResponseDto {
    if (!('onboardingUrl' in value) || value['onboardingUrl'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('isNewAccount' in value) || value['isNewAccount'] === undefined) return false;
    return true;
}

export function OnboardingResponseDtoFromJSON(json: any): OnboardingResponseDto {
    return OnboardingResponseDtoFromJSONTyped(json, false);
}

export function OnboardingResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnboardingResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'onboardingUrl': json['onboardingUrl'],
        'accountId': json['accountId'],
        'isNewAccount': json['isNewAccount'],
    };
}

export function OnboardingResponseDtoToJSON(json: any): OnboardingResponseDto {
    return OnboardingResponseDtoToJSONTyped(json, false);
}

export function OnboardingResponseDtoToJSONTyped(value?: OnboardingResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'onboardingUrl': value['onboardingUrl'],
        'accountId': value['accountId'],
        'isNewAccount': value['isNewAccount'],
    };
}

